import { render, staticRenderFns } from "./AddSystemBank.vue?vue&type=template&id=0c086094&scoped=true"
import script from "./AddSystemBank.vue?vue&type=script&lang=js"
export * from "./AddSystemBank.vue?vue&type=script&lang=js"
import style0 from "./AddSystemBank.vue?vue&type=style&index=0&id=0c086094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c086094",
  null
  
)

export default component.exports